function trackWebtrends(event: string) {
  const trackingParams = {
    'DCSext.wa_app': 'chat',
    'WT.dl': 'chat',
    'DCSext.wa_event_chat': event
  };
  // TODO: Replace with proper tracking
  // WebtrendsTrackingService.track(trackingParams);
  return trackingParams;
}

const webtrendsActions = {
  trackSendMessage() {
    const trackingParams = trackWebtrends('chat_text_submit');
    return {
      type: 'TRACK_SEND_MESSAGE',
      trackingParams
    };
  },
  trackStartChat() {
    const trackingParams = trackWebtrends('chat_start_customer_initiated');
    return {
      type: 'TRACK_START_CHAT',
      trackingParams
    };
  },
  trackDeclineOffer() {
    const trackingParams = trackWebtrends('chat_decline_proactive');
    return {
      type: 'TRACK_DECLINE_OFFER',
      trackingParams
    };
  },
  trackDeclineFurtherOffers() {
    const trackingParams = trackWebtrends('chat_decline_further_offers');
    return {
      type: 'TRACK_DECLINE_FURTHER_OFFERS',
      trackingParams
    };
  },
  trackAcceptChatOffer() {
    const trackingParams = trackWebtrends('chat_start_proactive_accept');
    return {
      type: 'TRACK_ACCEPT_CHAT_OFFER',
      trackingParams
    };
  }
};

export type WebtrendsActions = typeof webtrendsActions;

export default webtrendsActions;
